import FJModal from '../FJModal';
import FJGeneratingLoadingModal from './FJGeneratingLoadingModal.js';
import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import { FJModalsAction } from '@src/redux/action/FJModalsAction.ts';
import FJEventBridge from '@src/manager/FJEventBridge.ts';
import FJEventBridgeManager, { FJEventBridgeTarget } from '@src/manager/FJEventBridgeManager.ts';
import FJLoadingModalSlice from '@src/redux/slice/modal/FJLoadingModalSlice.ts';

const FJGeneratingLoadingModalContainer = () => {
    const dispatch = useAppDispatch();
    const { isShow, message, onlyLoading } = useAppSelector(state => {
        const loadingState = state.modal.loading;
        // 如果 loadingState 是布尔值，则没有 message
        return { isShow: loadingState.isShow, message: loadingState.message, onlyLoading: loadingState.onlyLoading };
    });

    const onclose = () => {
        const b: FJEventBridge = FJEventBridgeManager.getBridge(FJEventBridgeTarget.LOADING_MODAL);
        b.execute();
        FJEventBridgeManager.removeBridge(FJEventBridgeTarget.LOADING_MODAL);
        dispatch(FJLoadingModalSlice.actions.setIsCancel(true));
        dispatch(FJModalsAction.hideLoadingModalAction());
    };

    return (
        <FJModal visible={isShow} zIndex={10000}>
            <FJGeneratingLoadingModal desc={message} onclose={onclose} onlyLoading={onlyLoading} />
        </FJModal>
    );
};
export default FJGeneratingLoadingModalContainer;
